module.exports = __webpack_public_path__ + "img/img.aa493253.png";